import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Summer/Fractions/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Fractions',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/1IntroductionToPartsAndWhole" */ './1IntroductionToPartsAndWhole'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/2EqualAndUnequalParts" */ './2EqualAndUnequalParts'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/3RecogniseAHalf" */ './3RecogniseAHalf')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/4FindAHalf" */ './4FindAHalf')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/5RecogniseAQuarter" */ './5RecogniseAQuarter'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/6FindAQuarter" */ './6FindAQuarter')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/7RecogniseAThird" */ './7RecogniseAThird'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/8FindAThird" */ './8FindAThird')
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/9FindTheWhole" */ './9FindTheWhole')
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Fractions/10UnitFractions" */ './10UnitFractions')
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/11NonUnitFractions" */ './11NonUnitFractions'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/12RecogniseEquivalenceOfHalfAndTwoQuarters" */ './12RecogniseEquivalenceOfHalfAndTwoQuarters'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/13RecogniseThreeQuarters" */ './13RecogniseThreeQuarters'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/14FindThreeQuarters" */ './14FindThreeQuarters'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Fractions/15CountInFractionsUpToAWhole" */ './15CountInFractionsUpToAWhole'
        )
    })
  ]
});
export default Block;
